<template>
  <ScrollIntersectionObserver>
    <slot name="subjectImage" />
    <HintText data-test-id="ChoiceMultiple_HintText">
      {{
        maxAnswers === Infinity
          ? c('multiple_choice.select_answers')
          : c('multiple_choice.answer_limit', {
              quantity: maxAnswers,
              placeholders: { numAnswers: `${maxAnswers}` },
            })
      }}
    </HintText>
    <ChoiceFields
      data-test-id="ChoiceMultiple_ChoiceFields"
      :fields="fields"
      :selected-field-ids="selectedFieldIds"
      :max-answers="maxAnswers"
      @field-clicked="toggleAnswerChoice"
      @updated-text-choice="textInput => updateChoiceTextAnswer(textInput)"
    />
  </ScrollIntersectionObserver>
</template>
<script lang="ts">
import { type DeepReadonly, defineComponent, type PropType } from 'vue'

import { type Answer } from '../../../answer/models/Answer'
import { c } from '../../../intl'
import HintText from '../../../question/components/dumb/HintText.vue'
import { type Field } from '../../../question/models/Field'
import ScrollIntersectionObserver from '../../../shared/components/dumb/ScrollIntersectionObserver.vue'

import ChoiceFields from './ChoiceFields.vue'

export default defineComponent({
  components: { ChoiceFields, HintText, ScrollIntersectionObserver },
  props: {
    answers: {
      type: Array as PropType<DeepReadonly<Answer[]>>,
      required: true,
    },
    fields: { required: true, type: Array<Field> },
    maxAnswers: { required: true, type: Number },
    selectedFieldIds: { required: true, type: Set<string> },
  },
  emits: {
    answersUpdated: (_newAnswers: Answer[]) => true,
  },
  setup(props, { emit }) {
    const toggleAnswerChoice = (fieldToggled: string): void => {
      emit(
        'answersUpdated',
        props.answers.map(answer => {
          if (answer.fieldId !== fieldToggled) return answer
          if (answer.type !== 'choice')
            throw TypeError("Expected answer of type 'choice' or 'choiceText'")
          return {
            ...answer,
            value: {
              selected: !answer.value.selected,
            },
          }
        }),
      )
    }
    const updateChoiceTextAnswer = (textInput: string): void => {
      emit(
        'answersUpdated',
        props.answers.map(answer => {
          if (answer.fieldId !== 'other' || answer.type !== 'choiceText') return answer
          return { ...answer, value: { selected: textInput.length > 0, textInput } }
        }),
      )
    }

    return {
      toggleAnswerChoice,
      updateChoiceTextAnswer,
      c,
    }
  },
})
</script>
